import React from 'react';
import { Chrono } from 'react-chrono';
import { formatIndianNumber } from '../../utils/helper';

export default function Timeline({ items }) {
  return (
    <div style={{ height: '400px' }}>
      {items.length > 0 && (
        <Chrono
          items={items?.map((item) => ({
            title: `${item?.title}th`,
            cardTitle:
              item?.visible && item?.cardTitle ? (
                formatIndianNumber(item?.cardTitle)
              ) : (
                <span style={{ color: 'gray', pointerEvents: 'none' }}>-</span>
              ),
          }))}
          mode="VERTICAL_ALTERNATING"
          cardHeight={80}
          lineWidth={20}
          scrollable={true}
          disableToolbar={true}
          theme={{
            cardBgColor: 'white',
            cardForeColor: 'black',
          }}
        />
      )}
    </div>
  );
}
